import { combineReducers } from 'redux';
import { userActionType } from '../actions';
import user from './user';
import player from './player';
import notify from './notify';
import payment from './payment';
import preferences from './preferences';
import promo from './promo';
import worker from './worker';
import vpn from './vpn';
import role from './role';
import group from './group';
import stock from './stock';

const appReducer = combineReducers({
    user,
    player,
    notify,
    payment,
    preferences,
    promo,
    vpn,
    worker,
    role,
    group,
    stock
});

/**
 * Al logout (manuale o forzato dopo una refreshToken fallita) svuota tutto lo store riportandolo allo stato iniziale.
 * Viene mantenuta solo la versione del sito, che viene caricata una sola volta all'avvio.
 */
export default function rootReducer(state, action) {
    if (action.type === userActionType.LOGOUT_REQUEST) {
        const newState = appReducer(undefined, action);

        return {
            ...newState,
            preferences: {
                ...newState.preferences,
                versionSite: state ? state.preferences.versionSite : newState.preferences.versionSite
            }
        };
    }

    return appReducer(state, action);
}
